<template>
    <div id="agents-components">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <modal-stationery
                v-show="modalStationery"
                v-if="modalStationery"
                :supplier_id="itemId"
                :role_id="role_id"
                :folder_id="2"/>

            <modal-notes
                v-show="modalNotes"
                v-if="modalNotes"
                :user_id="user_id"
                :role_id="2"
                :supplier_id="itemId"/>

            <form v-show="modalForm" v-if="modalForm" id="formAgent" class="animated fadeIn margin-al-inputs formAgent">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="agent.currentName">
                    <input type="hidden" name="currentEmail" v-model="agent.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="agent.currentUserName">
                    <input type="hidden" name="currentFile" v-model="agent.currentFile">
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="agent.picture" :src="'../storage/agentes/'+agent.currentFile" alt="">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Imagen de Perfil <br>
                                <i class="fas fa-upload"></i>
                                <input type="file"
                                       data-label="avatar"
                                       name="imgUser"
                                       v-on:change="getLogo"
                                       placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info logo"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usara para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <hr>
                <h2 class="cabeza">Datos Generales</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <select v-model="agent.tipo_per" id="tipoPer" class="required" data-select="on"
                                data-name-input="Tipo de Persona" name="tipo_per">
                            <option :value="0">Selecciona un tipo de persona</option>
                            <option :value="1">Física</option>
                            <option :value="2">Moral</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select data-select="on" class="required" data-name-input="Status Agente" name="status_agente"
                                v-model="agent.status_agente" id="status_agente">
                            <option :value="0">Status del agente</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Suspendido</option>
                            <option :value="3">Baja</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-select="on" class="required" data-name-input="Promotor" name="promoter_id"
                                v-model="agent.promoter_id" id="promoter_id">
                            <option :value="0">Selecciona un promotor</option>
                            <option v-for="prom in promoters" :value="prom.id" :key="prom.id">{{
                                    prom.nmPromotor
                                }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <input name="comisionista" id="comisionista" type="text" class="al-inputs required scr-input"
                               placeholder="Nombre del Comisionista" v-model="agent.comisionista"/>
                        <label for="comisionista" class="scr-supertext">Nombre del Comisionista</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3">
                        <select id="estado" data-select="on" data-name-input="Estado" class="required" name="state_id"
                                v-model="agent.state_id" v-on:change="selectCities($event)">
                            <option :value="0">Selecciona un estado</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">{{
                                    state.estado
                                }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select name="cities_id" data-name-input="Ciudad" data-select="on" class="required" id="ciudad"
                                v-model="agent.cities_id">
                            <option :value="0">Selecciona una ciudad</option>
                            <option v-for="city in cities" :value="city.id">{{ city.ciudad }}</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="correo" name="correo" type="email" class="al-inputs required scr-input"
                               placeholder="E-mail" v-model="agent.correo"/>
                        <label for="correo" class="scr-supertext">E-mail</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="comision" name="comision" type="number" class="al-inputs required scr-input"
                               placeholder="Comisión" v-model="agent.comision"/>
                        <label for="comision" class="scr-supertext">Comisión</label>
                    </div>


                    <div class="col-12 col-md-3">
                        <input id="telefono" name="telefono" type="tel" class="al-inputs inputDate scr-input"
                               placeholder="Teléfono" v-model="agent.telefono"/>
                        <label for="telefono" class="scr-supertext">Teléfono</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="iva_agente" name="iva_agente" type="number" class="al-inputs inputDate scr-input"
                               placeholder="Iva" v-model="agent.iva_agente"/>
                        <label for="iva_agente" class="scr-supertext">Iva Agente</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <!--                        <input id="fechaFirma" name="fechaFirma" type="date" class="al-inputs inputDate"
                                                       placeholder="Fecha en el que se firma (dd-mm-yyyy)" v-model="agent.fechaFirma"/>-->
                        <date-picker inputName="fechaFirma" input-class="mx-input scr-input" v-model="agent.fechaFirma" format="YYYY-MM-dd" placeholder="Fecha firma contrato" lang="es"></date-picker>
                    </div>

                </div>

                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input id="username" name="username" type="text" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Usuario" v-model="agent.username"/>
                        <label for="username" class="scr-supertext">Usuario</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de usuario. La misma que se usa para iniciar
                            sesión.
                        </cite>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="pass" name="password" type="password" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Contraseña" v-model="agent.password"/>
                        <label for="pass" class="scr-supertext">Contraseña</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de contraseña. La misma que se usa para
                            iniciar sesión.
                        </cite>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(promotoria)="{item}">
                        <span v-if="item.relpromoter">
                            {{ item.relpromoter.nmPromotor }}
                        </span>
                                <span v-else></span>
                            </template>
                            <template #cell(agente)="data">
                                {{ data.item.comisionista }}
                            </template>
                            <template #cell(e-mail)="data">
                            <span v-if="data.item.reluser">
                                {{ data.item.reluser.email }}
                            </span>
                            </template>
                            <template #cell(status)="{item}">
                                <span v-if="item.status_agente===1"
                                      class="badge rounded-pill text-bg-success">Activo</span>
                                <span v-if="item.status_agente===2"
                                      class="badge rounded-pill text-bg-secondary">Suspendido</span>
                                <span v-if="item.status_agente===3"
                                      class="badge rounded-pill text-bg-danger">Baja</span>
                            </template>
                            <template #cell(comision)="{item}">
                                {{ item.comision }}
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a class="dropdown-item" :href="'factura-proveedor/2/'+user_id+'/'+item.id">Ver
                                            Facturas</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
//2024-01-25 16:28:40
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {agentsService} from "../../Services/Agents.service";
import {promotersService} from "../../Services/Promoters.service";
import {getFormData} from "../../Utils/getDataForm";
import {BootstrapVue, BPagination, IconsPlugin} from "bootstrap-vue";

export default {
    name: "agents",
    components: {
        DatePicker: () => import('vue2-datepicker'),
    },
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            filter: null,
            agent: {
                id: 0,
                state_id: 0,
                promoter_id: 0,
                cities_id: 0,
                user_id: 0,
                comisionista: '',
                rfc: '',
                calle: '',
                numero: '',
                colonia: '',
                telefono: '',
                codigo_postal: '',
                fechaFirma: '',
                nom_bco: '',
                banco: '',
                cuenta: '',
                clabe: '',
                correo_bco: '',
                rfc_bco: '',
                tel_bco: '',
                picture: '',
                tipo_per: 0,
                status_agente: 0,
                iva_agente: '',
                comision: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            },
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            fields: [
                {key: 'promotoria', sortable: false},
                {key: 'agente', sortable: false},
                {key: 'e-mail', sortable: false},
                {key: 'status', sortable: false},
                {key: 'comision', sortable: false},
                {key: 'acciones', sortable: false}
            ],
            states: [],
            cities: [],
            promoters: [],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Agregar',
            itemId: 0,
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await agentsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formAgent');
            const formData = getFormData('formAgent');
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await agentsService.updateOne(this.agent.id, formData, {isForm: true});
                } else {
                    resp = await agentsService.saveOne(formData, {isForm: true});
                }
                this.modificar = false;
                //this.modalForm = false;
                this.showModal = false;
                this.tituloBtn = 'Agregar';
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.states = await estadoService.getMany({limit: 0});
            this.promoters = await promotersService.getMany({limit: 0});
            switch (this.role_id) {
                case 5:
                    this.agent.promoter_id = this.user_id;
                    this.params.where = [
                        {
                            field: 'promoter_id',
                            operator: '=',
                            value: this.user_id
                        }
                    ];
                    break;
            }
            this.pagination = await agentsService.getMany(this.params);
            this.isBusy = false;
        },
        async selectCities($e) {
            let state_id = this.stateId($e);
            this.cities = await statescitiesService.getCitiesByState(state_id);
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.selectCities(data.state_id);
                this.tituloBtn = 'Actualizar';
                this.agent = data;
                this.agent.cities_id = data.relcities.id;
                this.agent.correo = data.reluser.email;
                this.agent.currentName = data.comisionista;
                this.agent.currentEmail = data.reluser.email;
                this.agent.currentUserName = data.reluser.username;
                this.agent.username = data.reluser.username
                this.agent.currentFile = data.picture;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.agent = {
                id: 0,
                state_id: 0,
                promoter_id: 0,
                cities_id: 0,
                user_id: 0,
                comisionista: '',
                rfc: '',
                calle: '',
                numero: '',
                colonia: '',
                telefono: '',
                codigo_postal: '',
                fechaFirma: '',
                nom_bco: '',
                banco: '',
                cuenta: '',
                clabe: '',
                correo_bco: '',
                rfc_bco: '',
                tel_bco: '',
                picture: '',
                status_agente: 0,
                iva_agente: '',
                comision: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>
<style scoped></style>
